module.exports = __webpack_public_path__ + "static/media/noun_Flight_black_3406429.b10a651c.svg";